import { render, staticRenderFns } from "./form_detail_novelties_component.vue?vue&type=template&id=8897f3b8&scoped=true"
import script from "./form_detail_novelties_component.vue?vue&type=script&lang=js"
export * from "./form_detail_novelties_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_novelties_component.vue?vue&type=style&index=0&id=8897f3b8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8897f3b8",
  null
  
)

export default component.exports